import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Box,
  Typography,
  Grid,
  useTheme,
} from "@mui/material";
import * as Constant from "../../features/constant";
import {
  useGetWithdrawDetailsQuery,
} from "../../features/api/transactionApiSlice";

const WalletCard = ({ screens, token, depositDetails }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const apkUrl = `${window.location.origin}/${process.env.REACT_APP_APK}`;
  const location = useLocation();
  const openAppOrDownload = () => {
    const appLink = process.env.REACT_APP_APK_SCHEME;

    let appOpened = false;

    const handleVisibilityChange = () => {
      if (document.hidden) {
        appOpened = true;
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);

    const iframe = document.createElement("iframe");
    iframe.src = appLink;
    iframe.style.display = "none";
    document.body.appendChild(iframe);

    setTimeout(() => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      document.body.removeChild(iframe);

      if (!appOpened) {
        window.location.href = apkUrl;
      }
    }, 1500);
  };

  const {
    data: withdrawDetails,
  } = useGetWithdrawDetailsQuery();


  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        p: 1,
        backgroundColor: theme.palette.walletScreen,
      }}
    >
      <Grid container pt={0} spacing={1} justifyContent="center">
        {screens?.filter((screen) => {
            if (screen?.code?.toLowerCase() === "app" && process.env.REACT_APP_WALLETCARD_SHOW_APP_DOWNLOAD === "false") return false;
            return true;
          }).map((screen) => (
          <Grid
            item
            xs={3}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              cursor: "pointer",
              p: 0,
            }}
            onClick={() => {
              const noTokenRequired = ["referral", "app"].includes(screen?.code?.toLowerCase());

              if (!token && !noTokenRequired) {
                navigate({
                  pathname: location.pathname,
                  search: "?login=1",
                })
                return;
              }

              switch (screen?.code?.toLowerCase()) {
                case "promotion":
                case "vip":
                  navigate(Constant.getPath("/" + screen?.code));
                  break;
                case "app":
                  handleAppDownload();
                  break;
                case "referral":
                  if (process.env.REACT_APP_FOOTER_REPLACE_AFFILIATE_WITH_REFERRAL === "true") {
                    if (token) {
                      navigate(Constant.getPath("/referral"));
                    } else {
                      navigate({
                        pathname: location.pathname,
                        search: "?login=1",
                      })
                    }
                  } else {
                    // Original affiliate logic
                    const affiliateSite = process.env.REACT_APP_AFFILIATE_SITE;

                    navigate(Constant.getPath("/affiliate"), {
                      state: {
                        screen: "Affiliate",
                      }
                    });
                  }
                  break;
                case "deposit":
                  navigate(Constant.getPath("/" + screen?.code.toLowerCase()), {
                    state: {
                      depositDetails: depositDetails
                    }
                  });
                  break;
                case "withdrawal":
                  navigate(Constant.getPath("/" + screen?.code.toLowerCase()), {
                    state: {
                      withdrawDetails: withdrawDetails?.result,
                    }
                  });
                  break;

                default:
                  navigate(Constant.getPath("/" + screen?.code.toLowerCase()), {
                  });
              }
            }}
          >
            {screen?.icon}
            <Typography textAlign="center" fontSize={10} color={process.env.REACT_APP_COLOR_WALLETCARD_TEXT || "white"}>
              {screen?.label}
            </Typography>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default WalletCard;
